module.exports = __webpack_public_path__ + "img/charging-station-infographic-desktop.189a5212.webp";